const items = [
  {
    id: 1,
    name: 'Essential Tee',
    price: '€24.99',
    category: 'Tops',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    description: 'Soft, breathable cotton in neutral tones. A wardrobe staple for every occasion.',
    image: 'https://images.pexels.com/photos/9558265/pexels-photo-9558265.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/9558265/pexels-photo-9558265.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/9558711/pexels-photo-9558711.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/9558761/pexels-photo-9558761.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 2,
    name: 'Classic Overshirt',
    price: '€49.99',
    category: 'Tops',
    sizes: ['S', 'M', 'L', 'XL'],
    description: 'A versatile layer that works from morning coffee to an evening out.',
    image: 'https://images.pexels.com/photos/13961680/pexels-photo-13961680.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/13961680/pexels-photo-13961680.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/26891518/pexels-photo-26891518.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/26891541/pexels-photo-26891541.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 3,
    name: 'Slim Chinos',
    price: '€39.99',
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    description: 'Tailored fit with stretch fabric. Dress them up or down effortlessly.',
    image: 'https://images.pexels.com/photos/26855385/pexels-photo-26855385.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/26855385/pexels-photo-26855385.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/15241166/pexels-photo-15241166.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/7276013/pexels-photo-7276013.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 4,
    name: 'Linen Shirt',
    price: '€34.99',
    category: 'Tops',
    sizes: ['XS', 'S', 'M', 'L'],
    description: 'Lightweight and relaxed, made for warm days and easy styling.',
    image: 'https://images.pexels.com/photos/9637778/pexels-photo-9637778.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/9637778/pexels-photo-9637778.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/28806472/pexels-photo-28806472.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/27373532/pexels-photo-27373532.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 5,
    name: 'Relaxed Hoodie',
    price: '€44.99',
    category: 'Tops',
    sizes: ['S', 'M', 'L', 'XL'],
    description: 'Cozy heavyweight cotton. The kind of hoodie you reach for every day.',
    image: 'https://images.pexels.com/photos/7763203/pexels-photo-7763203.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/7763203/pexels-photo-7763203.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/7763199/pexels-photo-7763199.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/7763191/pexels-photo-7763191.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 6,
    name: 'Everyday Denim',
    price: '€54.99',
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL'],
    description: 'Classic straight-leg denim with a clean, minimal finish.',
    image: 'https://images.pexels.com/photos/9775494/pexels-photo-9775494.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/9775494/pexels-photo-9775494.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/9775478/pexels-photo-9775478.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/9775480/pexels-photo-9775480.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 7,
    name: 'Tailored Jacket',
    price: '€89.99',
    category: 'Outerwear',
    sizes: ['S', 'M', 'L'],
    description: 'A clean silhouette jacket that elevates any outfit instantly.',
    image: 'https://images.pexels.com/photos/30947679/pexels-photo-30947679.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/30947679/pexels-photo-30947679.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/30947674/pexels-photo-30947674.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/30947669/pexels-photo-30947669.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 8,
    name: 'Basic Sweatshirt',
    price: '€32.99',
    category: 'Tops',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    description: 'A clean, unbranded sweatshirt in earthy tones. Simple done right.',
    image: 'https://images.pexels.com/photos/7036556/pexels-photo-7036556.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/7036556/pexels-photo-7036556.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/9594089/pexels-photo-9594089.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/7036552/pexels-photo-7036552.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 9,
    name: 'Cotton Polo',
    price: '€29.99',
    category: 'Tops',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    description: 'A refined polo in piqué cotton. Smart casual at its best.',
    image: 'https://images.pexels.com/photos/33651017/pexels-photo-33651017.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/33651017/pexels-photo-33651017.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/33651002/pexels-photo-33651002.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/33651012/pexels-photo-33651012.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 10,
    name: 'Cargo Trousers',
    price: '€59.99',
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL'],
    description: 'Relaxed-fit cargo trousers with subtle utility details.',
    image: 'https://images.pexels.com/photos/17037282/pexels-photo-17037282.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/17037282/pexels-photo-17037282.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/14940986/pexels-photo-14940986.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/28684111/pexels-photo-28684111.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 11,
    name: 'Wool Overcoat',
    price: '€129.99',
    category: 'Outerwear',
    sizes: ['S', 'M', 'L', 'XL'],
    description: 'A long-line wool blend coat. Timeless structure for colder seasons.',
    image: 'https://images.pexels.com/photos/21835288/pexels-photo-21835288.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/21835288/pexels-photo-21835288.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/18822207/pexels-photo-18822207.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/18777866/pexels-photo-18777866.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
  {
    id: 12,
    name: 'Canvas Tote',
    price: '€19.99',
    category: 'Accessories',
    sizes: ['One Size'],
    description: 'Heavy-duty canvas tote with a clean minimal print. Built to last.',
    image: 'https://images.pexels.com/photos/19517005/pexels-photo-19517005.jpeg?auto=compress&cs=tinysrgb&w=600',
    images: [
      'https://images.pexels.com/photos/19517005/pexels-photo-19517005.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/19517458/pexels-photo-19517458.jpeg?auto=compress&cs=tinysrgb&w=600',
      'https://images.pexels.com/photos/27048791/pexels-photo-27048791.jpeg?auto=compress&cs=tinysrgb&w=600',
    ],
  },
];

export default items;